import { render, staticRenderFns } from "./TransRecord.vue?vue&type=template&id=a0aabafe"
import script from "./TransRecord.vue?vue&type=script&lang=js"
export * from "./TransRecord.vue?vue&type=script&lang=js"
import style0 from "./TransRecord.vue?vue&type=style&index=0&id=a0aabafe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports